import React from 'react'
import { Table } from 'reactstrap'
import moment from 'moment'
import filesize from 'filesize'
import { generateDownloadLink } from '../utils/content'

export default ({ documents }) => (
  <Table>
    <tbody>
    {documents.map(document => (
        <tr key={document.id}>
          <td>
            {document.name}<br/>
            <small>{moment(document.published_at).format('DD.MM.YYYY, HH:mm')}</small>
          </td>
          <td>
            {filesize(document.size, {exponent: 2})}
          </td>
          <td>
            <a href={generateDownloadLink(document.file_id)} target="_blank" rel="noopener noreferrer">
              <i className="fa fa-download fa-lg"/>
            </a>
          </td>
        </tr>
      )
    )}
    </tbody>
  </Table>
)
